import { combineReducers } from 'redux';
import byId from './byId';

export default combineReducers({ byId });
